module.exports = __webpack_public_path__ + "img/bg.8454d615.png";